import { styled } from "@mui/material/styles";
import { Box, Typography, Button, TextField } from "@mui/material";

const BORDER = "#E5E7EB";
const TEXT = "#111827";
const DISABLED = "#9CA3AF";
const BLACK = "#000000";

export const AskQuestionButton = styled(Button)({
  height: "32px",
  padding: "0 14px",
  margin: "20px",
  borderRadius: "0px",
  fontSize: "13px",
  fontWeight: 500,
  textTransform: "none",
  background: BLACK,
  color: "#FFFFFF",
  boxShadow: "none",

  "&:hover": {
    background: BLACK,
    boxShadow: "none",
  },
});

export const Overlay = styled(Box)({
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1300,
});

export const ModalWrapper = styled(Box)({
  width: "520px",
  background: "#FFFFFF",
  borderRadius: "0px",
  boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
  height:"450px",
  overflowY:"auto",
   /* Firefox */
  scrollbarWidth: "thin",
  scrollbarColor: "#A100FF #CFCFCF",

  /* Chrome, Edge, Safari */
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#CFCFCF",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#A100FF",
  },
});

export const ModalHeader = styled(Box)({
  height: "45px",
  padding: "0 20px",
  borderBottom: `1px solid ${BORDER}`,
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F1F1EF",
  borderTop: "2px solid #A100FE"
});

export const ModalTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  color: TEXT,
  fontFamily: "Graphik-Regular",
});

export const ModalBody = styled(Box)({
  padding: "8px 20px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const Label = styled(Typography)({
  fontSize: "13px",
  fontFamily: "Graphik-Semibold",
  color: TEXT,
  marginBottom: "6px",
});

export const Required = styled("span")({
  color: "#DC2626",
});

export const Field = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "35px",
    borderRadius: "0px",
    fontSize: "14px",
  },
});

export const TextArea = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "100px",
    alignItems: "flex-start",
    borderRadius: "0px",
    fontSize: "14px",
  },
});

export const CounterText = styled(Typography)({
  fontSize: "12px",
  color: "#6B7280",
  textAlign: "left",
  marginTop: "4px",
});

export const ModalFooter = styled(Box)({
  padding: "5px 20px",
  borderTop: `1px solid ${BORDER}`,
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  backgroundColor: "#F1F1EF",
});

export const CloseButton = styled(Button)({
  width: "150px",
  height: "30px",
  borderRadius: "0px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: "600",
  borderColor: BLACK,
  color: TEXT,
  border: "2px solid #CFCFCF"
});

export const PostButton = styled(Button)(({ disabled }) => ({
  width: "150px",
  height: "30px",
  borderRadius: "0px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 600,

  background: disabled ? "#CFCFCF" : "#555555",
  borderColor: disabled ? "#CFCFCF" : "#555555",
  color: "#fff",
  background:"#000",
  cursor: disabled ? "not-allowed" : "pointer",

  "&:hover": {
    background: disabled ? "#CFCFCF" : "#000",
  },

  "&:disabled": {
    background: "#CFCFCF",
    color: "#555555",
  },
}));

